import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { useDispatch } from 'react-redux';
import WidgetModel from '@mm/state/model/WidgetModel';
import { uploadAudio } from '@mm/state/actions/uploadActions';
import AudioWidget from '../../../editor/features/build/requestModels/widgets/AudioWidget';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';

export const useAudioWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const dispatch: Dispatch<StoreState> = useDispatch();

  const addAudioToWidget = async (widget: WidgetModel, file: File) => {
    const id = await dispatch(
      uploadAudio({
        content: file,
        extension: file.name.split('.').pop() || '',
      }),
    );

    await commonWidgetHandlers.update({
      ...widget,
      config: {
        ...widget.config,
        assetId: id,
        description: file.name,
      },
    });
  };

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = AudioWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
    addAudioToWidget,
  };
};
